import MissingPodCell from './container';

export default MissingPodCell;
